import React, { useEffect, useRef, useState } from 'react'
import './App.css'
import './Customer.css'
import { Link } from 'react-router-dom'
import ClipLoader from 'react-spinners/ClipLoader'
import Axios from 'axios'
import validator from 'validator'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { API_URL } from './config'

const Customer = () => {
  const history = useHistory()

  const [fname, setFname] = useState('')
  const [lname, setLname] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [pass1, setPass1] = useState('')
  const [pass2, setPass2] = useState('')
  const [response, setResponse] = useState('')
  const [error, setError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [spinning, setSpinning] = useState('none')
  const [updateDisplay, setUpdateDisplay] = useState('block')
  const [disabled, setDisabled] = useState(false)

  const timeoutRef = useRef(null)

  useEffect(() => {
    document.title = 'Karamale | Customer registration'

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const showError = (message) => {
    setError(message)
    setErrorDisplay('block')
    setSpinning('none')
    setUpdateDisplay('block')

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      setErrorDisplay('none')
    }, 5000)
  }

  const onSubmitForm = () => {
    setErrorDisplay('none')
    setResponse('')
    setUpdateDisplay('none')
    setSpinning('block')

    if (fname.trim() === '' && lname.trim() === '') {
      showError('Please enter your first name and surname.')
      return
    }

    if (fname.trim() === '') {
      showError('First name is required.')
      return
    }

    if (lname.trim() === '') {
      showError('Surname is required.')
      return
    }

    if (email.trim() === '') {
      showError('Enter your email address.')
      return
    }

    if (!validator.isEmail(email.trim())) {
      showError('Your email address is invalid.')
      return
    }

    if (phone.trim() === '') {
      showError('Enter your phone number.')
      return
    }

    if (pass1.length < 8) {
      showError('Password must be at least 8 characters long.')
      return
    }

    if (pass1 !== pass2) {
      showError('Make sure both your passwords match.')
      return
    }

    setDisabled(true)

    const baseURL = `${API_URL}/apps/kscanner/webservices.php?`
    const data = new FormData()
    const customername = `${fname.trim()} ${lname.trim()}`

    data.append('account_name', customername)
    data.append('phone', phone)
    data.append('email', email.trim())
    data.append('accounttype', 'customer')
    data.append('platform', 'web')
    data.append('query', 'VERIFYACCOUNT')

    Axios({
      method: 'POST',
      url: baseURL,
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.status === 'success') {
          localStorage.setItem('verificationAccount', 'CUSTOMER')

          history.push({
            pathname: '/verification',
            state: {
              email: email.trim(),
              accounttype: 'customer',
              password: pass1,
            },
          })
        } else {
          showError(response.data.message)
          setDisabled(false)
        }
      })
      .catch((error) => {
        console.error(error)
        showError('Something went wrong. Please try again.')
        setDisabled(false)
      })
  }

  return (
    <div className="kx-customer-page">
      <div className="kx-customer-bg">
        <div className="kx-customer-bg__orb kx-customer-bg__orb--one" />
        <div className="kx-customer-bg__orb kx-customer-bg__orb--two" />
        <div className="kx-customer-bg__grid" />
        <div className="kx-customer-bg__word">KARAMALE</div>
      </div>

      <main className="kx-customer">
        <div className="kx-customer__wrap">
          {/* LEFT BRANDING */}

          <section className="kx-customer__brand">
            <Link to="/" className="kx-customer__logo">
              karamale<span>.</span>
            </Link>

            <div className="kx-customer__brand-content">
              <span className="kx-customer__eyebrow">TICKET BUYER</span>

              <h1>
                Your next
                <strong> experience </strong>
                is waiting.
              </h1>

              <p>
                Create your Karamale account and get simple, secure access to events worth showing
                up for.
              </p>

              <div className="kx-customer__features">
                <div className="kx-customer__feature">
                  <span>01</span>
                  <div>
                    <strong>Discover events</strong>
                    <small>Find concerts, experiences and events around you.</small>
                  </div>
                </div>

                <div className="kx-customer__feature">
                  <span>02</span>
                  <div>
                    <strong>Buy tickets securely</strong>
                    <small>Your tickets, purchases and event access in one place.</small>
                  </div>
                </div>

                <div className="kx-customer__feature">
                  <span>03</span>
                  <div>
                    <strong>Keep everything together</strong>
                    <small>Access your tickets whenever you need them.</small>
                  </div>
                </div>
              </div>
            </div>

            <div className="kx-customer__brand-footer">
              Already have an account?
              <Link to="/login">Log in</Link>
            </div>
          </section>

          {/* REGISTRATION PANEL */}

          <section className="kx-customer__panel">
            <div className="kx-customer__card">
              <div className="kx-customer__card-head">
                <span className="kx-customer__card-kicker">CREATE ACCOUNT</span>

                <h2>Sign up to buy tickets</h2>

                <p>
                  Set up your account in a few moments and start exploring what’s happening on
                  Karamale.
                </p>
              </div>

              <div className="kx-customer__form">
                <div className="kx-customer__row">
                  <div className="kx-customer__field">
                    <label>First name</label>

                    <input
                      type="text"
                      value={fname}
                      placeholder="Your first name"
                      onChange={(e) => setFname(e.target.value)}
                      autoComplete="given-name"
                    />
                  </div>

                  <div className="kx-customer__field">
                    <label>Surname</label>

                    <input
                      type="text"
                      value={lname}
                      placeholder="Your surname"
                      onChange={(e) => setLname(e.target.value)}
                      autoComplete="family-name"
                    />
                  </div>
                </div>

                <div className="kx-customer__field">
                  <label>Email address</label>

                  <input
                    type="email"
                    value={email}
                    placeholder="you@example.com"
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                  />
                </div>

                <div className="kx-customer__field">
                  <label>Phone number</label>

                  <PhoneInput
                    country="za"
                    value={phone}
                    onChange={setPhone}
                    enableSearch
                    disableDropdown={false}
                    inputStyle={{
                      width: '100%',
                    }}
                    containerStyle={{
                      width: '100%',
                    }}
                    buttonStyle={{
                      border: 'none',
                      borderRight: '1px solid #e5e5e5',
                      background: '#f7f7f7',
                      borderRadius: '10px 0 0 10px',
                    }}
                    inputProps={{
                      name: 'phone',
                      required: true,
                      autoComplete: 'tel',
                    }}
                  />
                </div>

                <div className="kx-customer__row">
                  <div className="kx-customer__field">
                    <label>Password</label>

                    <input
                      type="password"
                      value={pass1}
                      placeholder="Minimum 8 characters"
                      onChange={(e) => setPass1(e.target.value)}
                      autoComplete="new-password"
                    />
                  </div>

                  <div className="kx-customer__field">
                    <label>Confirm password</label>

                    <input
                      type="password"
                      value={pass2}
                      placeholder="Repeat your password"
                      onChange={(e) => setPass2(e.target.value)}
                      autoComplete="new-password"
                    />
                  </div>
                </div>

                <div className="kx-customer__terms">
                  By creating an account, you agree to our{' '}
                  <Link to="/terms-conditions" target="_blank">
                    Terms & Conditions
                  </Link>
                  ,{' '}
                  <Link to="/ticketing-policy" target="_blank">
                    Ticketing Policy
                  </Link>{' '}
                  and{' '}
                  <Link to="/refund-policy" target="_blank">
                    Refund Policy
                  </Link>
                  .
                </div>

                <div className="kx-customer__error" style={{ display: errorDisplay }}>
                  {error}
                </div>

                <div
                  className="kx-customer__response"
                  style={{
                    display: response ? 'block' : 'none',
                  }}
                >
                  {response}
                </div>

                <button
                  type="button"
                  onClick={onSubmitForm}
                  className="kx-customer__submit"
                  disabled={disabled}
                >
                  <span style={{ display: updateDisplay }}>
                    Create account
                    <span className="kx-customer__submit-arrow">→</span>
                  </span>

                  <span style={{ display: spinning }}>
                    <ClipLoader color="#ffffff" loading={true} size={20} />
                  </span>
                </button>
              </div>

              <div className="kx-customer__login">
                <span>Already have an account?</span>

                <Link to="/login">
                  Log in
                  <span>→</span>
                </Link>
              </div>

              <div className="kx-customer__back">
                <Link to="/">← Back to Karamale</Link>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  )
}

export default Customer
